import React from 'react';

export const PropertyTypeGroupPropertyType = ({
  propertyTypeGroupInPropertyType,
  handlePropertyType,
  propertyTypeId,
}) => {
  return (
    <div className="property-filter-block">
      {propertyTypeGroupInPropertyType && (
        <label className="property-details-label">Property Type</label>
      )}
      <div className="property-pill-grid">
        {propertyTypeGroupInPropertyType &&
          React.Children.toArray(
            propertyTypeGroupInPropertyType?.map((propertyType) => (
              <button
                type="button"
                className={`property-pill ${
                  // eslint-disable-next-line eqeqeq
                  propertyTypeId == propertyType?.id
                    ? 'property-pill--active'
                    : ''
                }`}
                onClick={handlePropertyType}
                data-propertytype={propertyType?.id}
              >
                {propertyType?.text}
              </button>
            )),
          )}
      </div>
    </div>
  );
};
